import style from './share-buttons.module.scss';
import ShareState, { IShareButton } from './share-state';
import { useEffect, useState } from 'react';

const ShareButtons = () => {
  const [pageUrl, setPageUrl] = useState('');
  useEffect(() => {
    setPageUrl(window.location.href);
  }, []);

  const openPopup = (item: IShareButton) => {
    window.open(
      item.link(pageUrl),
      'Sharer',
      'popup, width=500px, height=500px, top=200px, left=500px',
    );
  };

  return (
    <div className={style.container}>
      {ShareState.map((item, index: number) => {
        return (
          <div
            className={`${style.container__item} ${item.className} `}
            onClick={() => openPopup(item)}
            key={index}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: item.icon,
              }}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

export default ShareButtons;
